// Vue observes this shared object in the UI; route remounts retain unread state.
export const supportNotifications = { unread: 0, visible: false, openRequest: 0, muted: false };
let titleTimer, baseTitle, lastTitle, audio;

export function clearSupportUnread(host) {
    supportNotifications.unread = 0;
    if (titleTimer) host.clearInterval(titleTimer);
    titleTimer = null;
    if (lastTitle && host.document.title === lastTitle) host.document.title = baseTitle;
    lastTitle = null;
}

export function unlockSupportSound(host) {
    try {
        const Context = host.AudioContext || host.webkitAudioContext;
        if (!audio && Context) audio = new Context();
        if (audio && audio.state === 'suspended') audio.resume().catch(() => {});
    } catch (error) { /* Browser may require another user gesture. */ }
}

export function notifySupportReply(host) {
    supportNotifications.unread++;
    if (!titleTimer) {
        baseTitle = host.document.title;
        titleTimer = host.setInterval(() => {
            if (lastTitle && host.document.title !== lastTitle) baseTitle = host.document.title;
            lastTitle = host.document.title === baseTitle ? '(' + supportNotifications.unread + ') رد جديد من الدعم' : baseTitle;
            host.document.title = lastTitle;
        }, 1200);
    }
    if (supportNotifications.muted || !audio || audio.state !== 'running') return;
    try {
        [880, 660].forEach((frequency, i) => {
            const oscillator = audio.createOscillator(), gain = audio.createGain();
            const time = audio.currentTime + i * 0.16;
            oscillator.connect(gain); gain.connect(audio.destination);
            oscillator.frequency.value = frequency;
            gain.gain.setValueAtTime(0.0001, time);
            gain.gain.exponentialRampToValueAtTime(0.12, time + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.0001, time + 0.35);
            oscillator.start(time); oscillator.stop(time + 0.4);
            oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
        });
    } catch (error) { /* Audio must never block incoming messages. */ }
}

export function resetSupportNotifications(host) {
    clearSupportUnread(host);
    supportNotifications.visible = false;
}
